export function initScrollableTabs() {
  document.addEventListener('DOMContentLoaded', function () {
    const tabList = document.querySelectorAll('.scrollableTabs__item');
    const activeSlideIndex = [...tabList].indexOf(document.querySelector('.scrollableTabs__item--selected'));
    
    let tabsSlider = new window.splide('.scrollableTabs', {
      start: activeSlideIndex !== -1 ? activeSlideIndex : 1,
      pagination: false,
      arrows: false,
      autoWidth: true,
    });

    tabsSlider.on( 'overflow', function ( isOverflow ) {
      tabsSlider.go( 0 );

      tabsSlider.options = {
        drag: isOverflow,
        clones: isOverflow ? undefined : 0,
      };
    });
    
    tabsSlider.mount();
  });
}

export function changeTabContent() {
  document.addEventListener('DOMContentLoaded', function () {
    const tabsWithContent = document.querySelector('.scrollableTabs--withContent');
    const tabLinks = tabsWithContent.querySelectorAll('.scrollableTabs__link');
    
    if(tabLinks) {
      tabLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          const currentLink = e.target;
          const currentLinkParent = currentLink.parentNode;
          const tabContent = currentLink.getAttribute('data-tab');
          
          tabsWithContent.querySelector('.scrollableTabs__item--selected').classList.remove('scrollableTabs__item--selected');
          currentLinkParent.classList.add('scrollableTabs__item--selected');

          if(tabContent) {
            tabsWithContent.querySelector('.tab--visible').classList.remove('tab--visible');
            tabsWithContent.querySelector(`#${tabContent}`).classList.add('tab--visible');
          }
        });
      });
    }
  });
}